import { instance } from "libs/api";

import { ApiRoutesDrivers } from "../../constants";
import { Driver } from "../../drivers.types";
import { DriverPriorityPayload } from "./driverPriority.types";

export const requestDriverPriority = async (
  body: DriverPriorityPayload
): Promise<Driver[]> => {
  return await instance.put(ApiRoutesDrivers.DriverPriority, body);
};
